var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
let Aspect__ = class Aspect__ extends React.PureComponent {
    get aspectSiblings() {
        return this.props.aspect.global.aspectKey('siblingFromSkeleton').keyActive.activeTraits;
    }
    render() {
        // console.log('render Aspect__', this.props.aspect.readableIdentifier);
        /*
        if (!window.rr) window.rr = [];
    
        if (window.rr.includes(this.props.aspect.readableIdentifier) && this.props.aspect.readableIdentifier.includes('app')) {
          trace(true);
        } else {
          window.rr.push(this.props.aspect.readableIdentifier);
        }
    */
        /*
        if (this.props.aspect.readableIdentifier.includes('input')) {
          console.log(this.props.aspect.readableIdentifier, { ...this.props.aspect.aspectJsx.jsxAttributes });
        }
    */
        return (React.createElement(React.Fragment, null,
            this.aspectMount.mountComponent.aspectComponent,
            this.aspectSiblings.map(sibling => sibling.componentResultingFromAttachedTrait)));
    }
    get aspectMount() {
        return this.props.aspect.aspectMounts.getMountForComponent(this);
    }
    componentDidMount() {
        this.props.aspect.aspectMounts.mountAspect(this);
        this.aspectMount.setDomNode();
    }
    componentDidUpdate(prevProps) {
        if (this.props.aspect !== prevProps.aspect) {
            prevProps.aspect.aspectMounts.unMountAspect(this);
            this.props.aspect.aspectMounts.mountAspect(this);
        }
        try {
            this.props.aspect.aspectMount.setDomNode();
        }
        catch (e) {
            console.error('could not set dom node', e);
        }
    }
    componentWillUnmount() {
        this.props.aspect.aspectMounts.unMountAspect(this);
        if (this.props.aspect.aspectMount.measureDom.lastResizeObserver) {
            this.props.aspect.aspectMount.measureDom.lastResizeObserver.disconnect();
        }
        if (this.props.aspect.aspectMount.measureDom.lastMutationObserver) {
            this.props.aspect.aspectMount.measureDom.lastMutationObserver.disconnect();
        }
    }
};
Aspect__ = __decorate([
    observer
], Aspect__);
export { Aspect__ };
